import AsyncStorage from "@react-native-async-storage/async-storage";
import { setFCMToken } from "../../../Redux/Reducers/appConfigReducer";

export const requestNotificationPermission = () => {
    return async (dispatch, getState) => {
        console.log("request User Permission: Notification")

        const storedToken = await AsyncStorage.getItem('fcmToken');
        console.log("stored token: ", storedToken)
        if (storedToken) {
            dispatch(setFCMToken(storedToken));
            return true;
        }

        console.log("Web platform: skipping FCM setup.");
        return true;
    }
};